/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateExternalApiKeyV1Dto = {
  /**
   * The External API Key
   */
  apiKey: string;
  /**
   * External API Key type
   */
  type: CreateExternalApiKeyV1Dto.type;
};
export namespace CreateExternalApiKeyV1Dto {
  /**
   * External API Key type
   */
  export enum type {
    BREVO = 'Brevo',
    YOU_SIGN = 'YouSign',
  }
}
